import React from "react";
import { about, facilities } from "../mock";
import { MapPin } from "lucide-react";
import useReveal from "../hooks/useReveal";

export default function About() {
  const [ref, inView] = useReveal();
  const [ref2, inView2] = useReveal();

  return (
    <section id="about" className="kse-section bg-slate-50">
      <div className="kse-container">
        <div ref={ref} className="grid lg:grid-cols-2 gap-14 items-center">
          <div className={`reveal ${inView ? "in-view" : ""}`}>
            <span className="kse-eyebrow">
              {about.eyebrow}
            </span>
            <h2 className="kse-h2 mb-6">
              {about.title}
            </h2>
            {about.paragraphs.map((p, i) => (
              <p key={i} className="text-slate-600 leading-relaxed mb-4 text-[15px] sm:text-base">
                {p}
              </p>
            ))}
          </div>
          <div className={`relative reveal ${inView ? "in-view" : ""}`} style={{ animationDelay: "0.15s" }}>
            <div className="absolute -top-5 -left-5 w-28 h-28 bg-blue-100 rounded-3xl -z-0" />
            <img
              src={about.image}
              alt="KSE production team"
              className="relative rounded-3xl shadow-2xl w-full h-[420px] object-cover z-10"
            />
          </div>
        </div>

        {/* Facilities */}
        <div ref={ref2} className="mt-24">
          <h3 className="text-2xl sm:text-3xl font-bold text-[#1a2a6b] mb-10 text-center">
            Three Facilities. One Standard.
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            {facilities.map((f, i) => (
              <div
                key={f.name}
                className={`group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-300 border border-slate-100 reveal ${inView2 ? "in-view" : ""}`}
                style={{ animationDelay: `${i * 0.12}s` }}
              >
                <div className="h-48 overflow-hidden">
                  <img src={f.image} alt={f.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6">
                  <h4 className="text-xl font-bold text-[#1a2a6b]">{f.name}</h4>
                  <p className="flex items-center gap-1.5 text-[#2b3aa0] text-sm font-medium mt-1">
                    <MapPin size={14} /> {f.location}
                  </p>
                  <p className="text-slate-500 text-sm mt-3 leading-relaxed">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
